import { isEmpty } from 'lodash';

import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';
import objectToQuery from 'hb-react/shared/utils/objectToQuery';

export const makeFetchItems =
  ({ urls, tagsQueryKey }) =>
  ({ fetchFilters, page, signal }) => {
    const getFilters = () => {
      const { location, ...otherFilters } = fetchFilters.filters;

      return {
        ...(location &&
          objectToQuery(location, {
            getKey: (key) => `query[location][${key}]`,
          })),
        ...objectToQuery(otherFilters),
      };
    };

    const filters = fetchFilters?.filters && getFilters();

    return axios
      .get(urls.fetchItems, {
        params: {
          page,
          ...(isEmpty(filters) ? { 'query[pinned_on_index_page]': false } : {}),
          [tagsQueryKey]: Object.keys(fetchFilters.tags ?? {}).map((tag) =>
            tag.replace('tag-', ''),
          ),
          ...filters,
        },
        signal,
      })
      .then(({ data }) => ({
        items: data.requests,
        totalItems: data.total_items,
      }));
  };

export const makeFetchPinnedItems =
  ({ urls }) =>
  ({ page, signal }) => {
    const params = {
      page,
      'query[pinned_on_index_page]': true,
    };

    return axios
      .get(urls.fetchItems, {
        params,
        signal,
      })
      .then(({ data }) => ({
        items: data.requests,
        totalItems: data.total_items,
      }));
  };

export const makeDeleteItem =
  ({ urls }) =>
  ({ id }) =>
    axios.delete(urls.deleteItem({ opportunityId: id }));

export const fetchTagOptions = (url, params = {}) =>
  axios
    .get(url, { params })
    .then(({ data }) =>
      data.map((c) => ({
        name: `tag-${c.id}`,
        label: c.label,
        query: {
          [`tag-${c.id}`]: true,
        },
      })),
    )
    .catch((error) => {
      if (error?.response?.status !== 403) {
        displayXhrError(error);
      }
    });
